import BackgroundImageOnLoad from './BackgroundImageOnLoad'

export default BackgroundImageOnLoad
